import { useTranslations } from "next-intl";
import type { ReactNode } from "react";

import { ChannelLogoRow } from "./channel-logo-row";

/** Connected and own calendars as brand coins over the window's bottom-right edge. */
export function KalenderSourcesOverlay(): ReactNode {
  const t = useTranslations("marketing.moduleKalender");
  // i18n-exempt: brand names stay as written in every locale
  const brands = { outlook: "Outlook", gmail: "Gmail" } as const;
  return (
    <ChannelLogoRow
      items={[
        { channel: "outlook", label: brands.outlook },
        { channel: "gmail", label: brands.gmail },
        { channel: "calendar", label: t("eigeneKalender") },
      ]}
      style={{ position: "absolute", right: 28, bottom: -36, zIndex: 35 }}
    />
  );
}
